import { useCallback, useState } from 'react';

type ReturnType = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onOpen: (event: React.MouseEvent<HTMLElement>) => void;
  onClose: VoidFunction;
};

export const usePopover = (): ReturnType => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const onClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);

  return {
    open,
    anchorEl,
    onOpen,
    onClose
  };
};
